export const initialFilterState = {
  sortBy: null,
  categories: [],
  rating: 5,
  priceLow: [],
  priceHigh: [],
  searchQuery: "",
};
